// @flow
import * as React from 'react'
import { trackFilterEvent } from 'analytics'
import type { RouterHistory } from 'react-router-dom'
import FilterGroup from './FilterGroup'

type Props = {
  initialFilter?: string,
  filters: Array<string>,
  children: (filter: string) => React.Node,
  history: RouterHistory,
}

type State = {
  filter: string,
}

class Filter extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      filter:
        props.initialFilter != null && props.initialFilter.length > 0
          ? props.initialFilter
          : '*',
    }
  }

  setFilter = (filter: string) => {
    this.setState({ filter })

    const { history } = this.props
    history.push({
      search: filter !== '*' ? filter : undefined,
    })

    trackFilterEvent(filter)
  }

  render() {
    const { children, filters } = this.props
    const { filter } = this.state
    return (
      <React.Fragment>
        <FilterGroup
          filters={filters}
          activeFilter={filter}
          setFilter={this.setFilter}
        />
        {children(filter)}
      </React.Fragment>
    )
  }
}

export default Filter



// WEBPACK FOOTER //
// ./src/components/Filter.js